import { Directive, HostListener, ElementRef } from '@angular/core';
import { Router } from '@angular/router';
import { environment } from 'src/environments/environment';

@Directive({
    selector: 'a[appExternalUrl]',
    standalone: false
})
export class ExternalUrlDirective {
    constructor(private el: ElementRef, private router: Router) {}

    @HostListener('click', ['$event'])
    clicked(event: Event) {
        const url = this.el.nativeElement.href;
        if (!url) {
            return;
        }
        // For error-page, the exit should take the user to old ireg landing page.
        if ( this.router.url === '/error-page') {
            return this.router.navigateByUrl('registration-dashboard');
        }
        this.router.navigate(['/externalRedirect', { externalUrl: url }], {
            skipLocationChange: true,
        });

        event.preventDefault();
    }
}